module.exports = __webpack_public_path__ + "static/media/wf_symbol.4487806c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/images/wf_symbol.png
// module id = 444
// module chunks = 0